import { Ldap } from './../models/ldap';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class LdapService {
  ldapServiceUrl = 'api/Authentication';
  constructor(private _authHttp: RestApi) { }

  getLdapConfiguration(): Observable<Ldap[]> {
    return this._authHttp.get(`${this.ldapServiceUrl}/ldap`);
  }

  getUserProperties(): Observable<any[]> {
    return this._authHttp.get(`${this.ldapServiceUrl}/userproperties`);
  }

  putLdap(body: string): Observable<any> {
    return this._authHttp.put(`${this.ldapServiceUrl}/LDAP`, body);
  }

  getLdapMetadata() {
    return this._authHttp.get(`${this.ldapServiceUrl}/LDAP/Metadata`);
  }

  testConnection(body: string): Observable<any> {
    return this._authHttp.post(`${this.ldapServiceUrl}/ldap/connection`, body);
  }
}
